


console.log('this is a console log');

//update copyright year

document.getElementById('copyright').appendChild(document.createTextNode(new Date().getFullYear()))




var $mobileFilter = jQuery('#mobileFilter');
var $FilterWrapper = jQuery('.filter_wrapper');

jQuery( document ).ready(function($) {
	
	//add class to body when user scrolls past 50px
	$(window).scroll(function() {    
	    var scroll = $(window).scrollTop();
	    // var alert_primary = $( '.alert-warning');
	    // var alert_secondary = $( '.alert-secondary');
	    // var scrollstart = 0;
	    // var scrollpoint = 0;
	    // if (alert_primary){
	    // 	scrollpoint = alert_primary.height();
	    // }

	    if (scroll > 0) {
	        $("body").addClass("user-scroll");
	        
	    } else {
	        $("body").removeClass("user-scroll");
	    }
	});

	$(window).resize(function(){
		
	  	if( $( window ).width() < 1200) {
			if ($('.nav-backdrop').is(':visible')) {
				$( '.nav-backdrop').fadeOut();
				$( '#dropdown-close').fadeOut();
			} else {
			  // do nothing for now
			}
		}

	});
// $( '.dropdown-toggle.nav-link' ).each(function(index) {
//     $(this).on('click', function(e){
//     	e.preventDefault();
// 		$( '.nav-backdrop').fadeIn( 500, function() {}  );
// 		$( '.lvnt-navbar').addClass('dropdown-open');
//     });
// });
// $( '.nav-backdrop' ).each(function(index) {
//     $(this).on('click', function(e){
//     	e.preventDefault();
// 		$( '.nav-backdrop').fadeOut( 500, function() {}  );
// 		$( '.lvnt-navbar').removeClass('dropdown-open');
//     });
// });
// $( '.lvnt-navbar.dropdown-open' ).each(function(index) {
//     $(this).on('click', function(e){
//     	e.preventDefault();
// 		$( '.nav-backdrop').fadeOut( 500, function() {}  );
// 		$( '.lvnt-navbar').removeClass('dropdown-open');
//     });
// });

$('.dropdown').on('hide.bs.dropdown', function (e) {
	// $(this).find('.dropdown-menu').first().stop(true, true).slideUp(500, function() {

	// });
	//$(this).find('.dropdown-menu').first().stop(true, true).removeClass('animate__fadeIn').addClass('animate__fadeOut');
	
	//$(this).find('.dropdown-menu').first().stop(true, true).removeClass('animate__slideInDown').addClass('animate__slideOutUp');
	
	$( '.lvnt-navbar, #main-nav').removeClass('dropdown-open');
	
	if( $( window ).width() > 1200) {
		$( '.nav-backdrop').fadeOut();
		$( '#dropdown-close').hide();
	}

});
$('.dropdown').on('show.bs.dropdown', function (e) {
	//$(this).find('.dropdown-menu').first().stop(true, true).removeClass('animate__fadeOut').addClass('animate__fadeIn');
	//$(this).find('.dropdown-menu').first().stop(true, true).removeClass('animate__slideOutUp').addClass('animate__slideInDown');
	$( '.lvnt-navbar, #main-nav').addClass('dropdown-open');
	
	if( $( window ).width() > 1200) {
		$( '.nav-backdrop').fadeIn();
		$( '#dropdown-close').fadeIn();
	}

});
//remove focus from modal on open
$('.modal').on('shown.bs.modal', function (e) {
	// Get the currently focused element
	let focusedElement = $(':focus'); // or $(document.activeElement)
	// Check if an element is focused
	if (focusedElement.length) {
	  // Remove focus from the element
	  focusedElement.blur();
	}
});
//remove focus from modal on hide
$('.modal').on('hide.bs.modal', function (e) {
    
	// Get the currently focused element
	let focusedElement = $(':focus'); // or $(document.activeElement)
	// Check if an element is focused
	if (focusedElement.length) {
	  // Remove focus from the element
	  focusedElement.blur();
	}

});

	//desktop filter
	$('.desktop .cat-list_item').on('click', function() {
		$('.desktop .cat-list_item').removeClass('active');
		$(this).addClass('active');
		if( $('#podchats_data').length ) {
			if (($(this).data('slug') == '') || ($(this).data('slug') == 'podchat')) {
				$('#podchats_data').removeClass('d-none');
			} else{
				$('#podchats_data').addClass('d-none');
			}
		}
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
				action: 'filter_cards',
				category: $(this).data('slug'),
			},
			success: function(res) {
				$('#card-row').html(res);
			}
		})
	});

	//mobile filter
	$('.cat-list .form-select').on('change', function() {
		if( $('#podchats_data').length ) {
			if (($(this).val() == '') || ($(this).val() == 'podchats')) {
				$('#podchats_data').removeClass('d-none');
			} else{
				$('#podchats_data').addClass('d-none');
			}
		}
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
				action: 'filter_cards',
				category: $(this).val(),
			},
			success: function(res) {
				$('#card-row').html(res);
			}
		})
	});




	$(function() {  
		//var $mobileFilter = $('#mobileFilter');
		if($mobileFilter.length == 0){
			//do nothing
			console.log('$mobileFilter does not exist');
		}else{
			// #mobileFilter exists
			console.log('$mobileFilter exists');
			$(window).scroll(function () { 
				if ($mobileFilter.offset().top - $(this).scrollTop() > 80.5) {
					$mobileFilter.removeClass('shadow');
					$FilterWrapper.removeClass('sticky-top');
				} else {
					$mobileFilter.addClass('shadow');
					$FilterWrapper.addClass('sticky-top');
				}
			});

		}
	});





	$('.wrapper .form-control').focus(function () {
		console.log('focus');
	    $(this).prev('.form-label').removeClass('hidden');
	    $(this).parent().addClass('active');
	}).blur(function () {
		console.log('lost focus');
	    $(this).prev('.form-label').addClass('hidden');
	    $(this).parent().removeClass('active');
	});







jQuery('.gform_body input').each(function () { 
	jQuery(this).on('focus', function () {
		jQuery(this).parent().parent('.gfield').addClass('active');
	}); 
	jQuery(this).on('blur', function () { 
		if (jQuery(this).val().length == 0) { 
			jQuery(this).parent().parent('.gfield').removeClass('active'); 
		} 
	}); 
	//if (jQuery(this).val() != '') jQuery(this).parent('.css').addClass('active'); 
	if (jQuery(this).val() != '') jQuery(this).parent().parent('.gfield').addClass('active'); 
});

jQuery('.gform_body .ginput_complex span input').each(function () { 
	jQuery(this).on('focus', function () {
		//jQuery(this).parent().parent('.ginput_complex span').addClass('active');  
		jQuery(this).parent().addClass('active');  
	}); 
	jQuery(this).on('blur', function () { 
		if (jQuery(this).val().length == 0) { 
			//jQuery(this).parent().parent('.ginput_complex span').removeClass('active'); 
			jQuery(this).parent().removeClass('active'); 
		} 
	}); 
	if (jQuery(this).val() != '') jQuery(this).parent('.css').addClass('active'); 
}); 

jQuery('.gform_body textarea').each(function () { 
	jQuery(this).on('focus', function () { 
		jQuery(this).parent().parent('.gfield').addClass('active'); 
	}); 
	jQuery(this).on('blur', function () { 
		if ($(this).val().length == 0) { 
			jQuery(this).parent().parent('.gfield').removeClass('active'); 
		} 
	}); 
	if (jQuery(this).val() != '') jQuery(this).parent('.css').addClass('active'); 
});


//End (document).ready

});




